import $ from 'jquery';
window.$ = window.jQuery = $;
import AOS from 'aos';
import "jquery-match-height/jquery.matchHeight";


import "@fortawesome/fontawesome-free/js/fontawesome.min";
import "@fortawesome/fontawesome-free/js/solid.min";
import "@fortawesome/fontawesome-free/js/regular.min";
import "@fortawesome/fontawesome-free/js/brands.min";


import {menuMain} from "./menu";
import {animations} from "./animations";
import {sliders} from "./sliders";
import {form} from "./form";

/****************************************************************************
 * Theme scripts.
 ****************************************************************************/


window.addEventListener('load', function() {
    AOS.refresh();
});

window.onload = function() {
    document.body.classList.add('is-ready');
};



(function( $ ){
    'use strict';

    setTimeout( () => {

        AOS.init({  duration: 1000, once: true, startEvent: 'load'});
        sliders.init();
        animations.init();
        form.init();



    }, 1 );

    setTimeout( () => {

// Check if the body has the 'debug' class

    }, 2000 );

    $(window).on('scroll', function (event) {
        AOS.refresh();
    });


} )( jQuery );
/***************
 * After theme scripts
 ***************/


// // Each time the window updates, refresh ScrollTrigger and then update LocomotiveScroll
// ScrollTrigger.addEventListener( 'refresh', () => scroll.update() );
//
// // After everything is set up, refresh() ScrollTrigger and update LocomotiveScroll because padding may have been added for pinning, etc.
// ScrollTrigger.refresh();
